import { render } from "./Choices.vue?vue&type=template&id=635c3c7e&ts=true"
import script from "./Choices.vue?vue&type=script&lang=ts"
export * from "./Choices.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__